module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hiusstudio-Gaia","short_name":"Hiusstudio-Gaia","start_url":"/","background_color":"#263f35ff","theme_color":"#263f35ff","display":"minimal-ui","icon":"src/components/valkoinenlogo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ea3e98e3c42dc811bc8c8f8c5f86ad03"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
